export const getCurrentContext = () => {
    var _a;
    return (_a = window.SilverSurferSDK.getContext()) === null || _a === void 0 ? void 0 : _a.current;
};
